import { Controller } from "@hotwired/stimulus";

// Generic map controller that works across all map providers
export default class extends Controller {
  static values = {
    mapId: String
  };

  connect() {
    // Dynamic map controller connected
  }

  // Generic method to center map on a specific location
  centerOnLocation(event) {
    const lat = parseFloat(event.currentTarget.dataset.lat);
    const lng = parseFloat(event.currentTarget.dataset.lng);
    
    if (isNaN(lat) || isNaN(lng)) {
      return;
    }

    // Try to find the map element and center it
    const mapElement = this.findMapElement();
    if (mapElement) {
      this.centerMapOnLocation(mapElement, lat, lng);
    }
  }

  findMapElement() {
    // Look for the map element within this controller's scope
    const mapElement = this.element.querySelector('[data-controller*="map"]');
    if (mapElement) {
      return mapElement;
    }

    // If not found, look for any map element in the page
    const allMapElements = document.querySelectorAll('[data-controller*="map"]');
    if (allMapElements.length > 0) {
      return allMapElements[0];
    }

    return null;
  }

  centerMapOnLocation(mapElement, lat, lng) {
    // Check which map controller is active and call the appropriate method
    if (mapElement.hasAttribute('data-controller')) {
      const controllers = mapElement.getAttribute('data-controller').split(' ');
      
      if (controllers.includes('google-map')) {
        this.centerGoogleMap(mapElement, lat, lng);
      } else if (controllers.includes('mapbox')) {
        this.centerMapboxMap(mapElement, lat, lng);
      } else if (controllers.includes('openstreetmap')) {
        this.centerOpenStreetMap(mapElement, lat, lng);
      }
    }
  }

  centerGoogleMap(mapElement, lat, lng) {
    // Access Google Maps controller if available
    const googleMapController = this.application.getControllerForElementAndIdentifier(mapElement, 'google-map');
    if (googleMapController && typeof googleMapController.centerOnGap === 'function') {
      googleMapController.centerOnGap({ currentTarget: { dataset: { lat, lng } } });
    }
  }

  centerMapboxMap(mapElement, lat, lng) {
    // Access Mapbox controller if available
    const mapboxController = this.application.getControllerForElementAndIdentifier(mapElement, 'mapbox');
    if (mapboxController && mapboxController.map) {
      mapboxController.map.setCenter([lng, lat]);
      mapboxController.map.setZoom(12);
    }
  }

  centerOpenStreetMap(mapElement, lat, lng) {
    // Access OpenStreetMap controller if available
    const osmController = this.application.getControllerForElementAndIdentifier(mapElement, 'openstreetmap');
    if (osmController && osmController.map) {
      osmController.map.setView([lat, lng], 12);
    }
  }
}
